import React, { useEffect, useState } from 'react';
import Dialog from 'components/dialogs/Dialog';
import { ProcedurePackage } from 'types/procedure';
import { IconButton, InputAdornment, styled, TextField, Tooltip, Typography } from '@mui/material';
import { moneyFormat } from 'helpers/moneyFormat';
import MoneyInput from 'components/masked-input/MoneyInput';
import { toast } from 'react-toastify';
import { useNewSurgerie } from '../hooks/useNewSurgerie';
import { Done } from '@mui/icons-material';
import { asInputComponent } from 'components/masked-input/asInputComponent';

interface EditPackageValueDialogProps {
  onExited(): void;
  selectedPkg: ProcedurePackage;
}

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 5,
  padding: 10,
}));

const Content = styled('div')({
  marginTop: 20,
});

const EditPackageValueDialog: React.FC<EditPackageValueDialogProps> = ({ onExited, selectedPkg }) => {
  const [value, setValue] = useState(0);
  const { handleChangePackages, surgerie } = useNewSurgerie();

  useEffect(() => {
    setValue(selectedPkg.package?.sale_price || 0);
  }, [selectedPkg]);

  function handleSubmit() {
    const updatedPackages = surgerie.packages.map(pkg => {
      if (pkg.id === selectedPkg.id) {
        return {
          ...pkg,
          package: {
            ...pkg.package,
            sale_price: value,
            id: pkg.package?.id ?? 0,
          },
        } as ProcedurePackage;
      }
      return pkg;
    });

    handleChangePackages(updatedPackages as ProcedurePackage[]);
    onExited();
  }

  function handleValidation() {
    if (value < (selectedPkg.package?.sale_price_min || 0)) {
      toast.warning('Atenção: o valor do pacote informado é menor que o valor de venda mínimo.');
    }
    handleSubmit();
  }

  return (
    <Dialog
      onExited={onExited}
      title="Editar valor do pacote"
      maxWidth="md"
      ComponentActions={
        <Tooltip title="Salvar">
          <IconButton size="small" color="inherit" onClick={handleValidation}>
            <Done />
          </IconButton>
        </Tooltip>
      }
    >
      <Container>
        <Typography variant="body2">
          Nome do pacote: <b>{selectedPkg.package?.name}</b>
        </Typography>
        <Typography variant="body2">
          Valor de custo: <b>{moneyFormat(selectedPkg.package?.cost_price)}</b>
        </Typography>
        <Typography variant="body2">
          Valor de venda mínimo: <b>{moneyFormat(selectedPkg.package?.sale_price_min)}</b>
        </Typography>
        <Typography variant="body2">
          Valor de venda máximo: <b>{moneyFormat(selectedPkg.package?.sale_price_max)}</b>
        </Typography>

        <Content>
          <TextField
            fullWidth
            label="Novo valor"
            variant="outlined"
            size="small"
            value={value}
            onChange={e => setValue(Number(e.target.value))}
            slotProps={{
              input: {
                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                inputComponent: asInputComponent(MoneyInput),
              },
            }}
          />
        </Content>
      </Container>
    </Dialog>
  );
};

export default EditPackageValueDialog;
